import { render } from "./VabeneAddUserPage.vue?vue&type=template&id=cfee5c84&ts=true"
import script from "./VabeneAddUserPage.vue?vue&type=script&lang=ts"
export * from "./VabeneAddUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__